import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-foreground-100 mb-4">
          准备好了吗？开启你的观影之旅
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-2xl mx-auto leading-relaxed">
          加入奇优影院，畅享海量高清影视资源。秒开播放，流畅不卡顿，让每一部电影都成为享受。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 rounded-lg text-base font-medium whitespace-nowrap transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            浏览全部影片
          </Link>
          <Link
            to="/category/tvseries"
            className="flex items-center gap-2 px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-200 rounded-lg text-base font-medium whitespace-nowrap transition-colors border border-background-300/30"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-tv-line text-lg"></i>
            </span>
            热门电视剧
          </Link>
        </div>
      </div>
    </section>
  );
}